import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { FlowsPage } from '../../FlowsPage';

export function HubFlowsPage() {
  return (
    <AuditWrapper>
      <FlowsPage />
    </AuditWrapper>
  );
}
